<template>
    <main id="mainCtrl">
        <header>
            <button :class="isSync ? 'loading' : ''" @click="syncAds">
                <span>Синхронизировать</span>
            </button>
        </header>

        <v-table id="table"
                 :key="uniq"
                 request-uri="context/getAdGroupList"
                 pagesize="50"
                 :lazycount="false"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="auto" sort="auto" width="50" tooltip="Автоматическое включение и выключение">
                        Авто
                    </v-th>
                    <v-th name="id" width="120">
                        ID объявления
                    </v-th>
                    <v-th name="clinic">
                        Клиника
                    </v-th>
                    <v-th name="city" width="170">
                        Город
                    </v-th>
                    <v-th name="state" sort="is_active" width="150">
                        Состояние
                    </v-th>
                    <v-th name="href">
                        Рекламная ссылка
                    </v-th>
                    <v-th name="subscription" width="50" tooltip="Подписка">
                        Подп.
                    </v-th>
                    <v-th name="date" width="200">
                        Дата подписки
                    </v-th>
                    <v-th name="company" width="200">
                        Кампания
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="auto" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "AUTO_ENABLED",
                                    text:  "✔ Включено"
                                },
                                {
                                    value: "AUTO_DISABLED",
                                    text: "✕ Отключено"
                                }
                            ]'
                        />
                    </v-th>
                    <v-th name="id" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinic" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="city" v-slot="{filter}">
                          <v-select
                                v-model="filter.value"
                                :options='[
                                    {
                                        value: "",
                                        text: "\u00a0"
                                    },
                                    ...cityOptions
                                ]'
                        />
                    </v-th>
                    <v-th name="state" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "STATE_ON",
                                    text:  "Идут показы"
                                },
                                {
                                    value: "STATE_OFF",
                                    text: "Показы остановлены"
                                }
                            ]'
                        />
                    </v-th>
                    <v-th name="href" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="subscription" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "HAVE_SUBSCRIPTION",
                                    text:  "✔ Есть"
                                },
                                {
                                    value: "NO_SUBSCRIPTION",
                                    text: "✕ Нет"
                                },
                                {
                                    value: "UNKNOWN_SUBSCRIPTION",
                                    text: "? Неизвестно"
                                }
                            ]'
                        />
                    </v-th>
                    <v-th name="date">
                        <input disabled>
                    </v-th>
                    <v-th name="company" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "63736129",
                                    text: "63736129"
                                },
                                {
                                    value: "108560981",
                                    text: "108560981"
                                },
                            ]'
                        />
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }" @click="edit(item)">
                <v-tr>
                    <v-td name="auto" align="center">
                        <input type="checkbox" v-model="item.auto" @change="autoSetting(item)">
                    </v-td>
                    <v-td name="id" align="center">
                        <a :href="`https://direct.yandex.ru/dna/banners-edit?ulogin=docturu&campaigns-ids=63736129&banners-ids=${item.id}`"
                            target="_blank"
                        >
                            {{item.id}}
                        </a>
                    </v-td>
                    <v-td name="clinic" align="left">
                        <span>{{ item.clinic_name }}</span>
                    </v-td>
                    <v-td name="city" align="center">
                        {{ item.city }}
                    </v-td>
                    <v-td name="state" align="center">
                        <span v-if="item.is_active">
                            <i style="color: green" class="fa-solid fa-play"></i>
                            Идут показы
                        </span>
                        <span v-else>
                             <i style="color: orangered" class="fa-solid fa-stop"></i>
                            Показы остановлены
                        </span>
                    </v-td>
                    <v-td name="href" align="center">
                        <a :href="item.href" target="_blank">{{item.url ?? item.href}}</a>
                    </v-td>
                    <v-td name="subscription" align="center">
                        <i v-if="item.active_subscription !== null && item.active_subscription" style="color: green" class="fa-solid fa-check"></i>
                        <i v-else-if="item.active_subscription === null" class="fa-solid fa-question"></i>
                        <i v-else style="color: red" class="fa-solid fa-ban"></i>
                    </v-td>
                    <v-td name="date">
                        <span v-if="item.last_subscription">
                            <span> с </span>
                            {{ item.last_subscription.dateFrom | formatDate }}
                            <span> до </span>
                            {{ item.last_subscription.dateTill | formatDate }}
                        </span>
                        <span v-else></span>
                    </v-td>
                    <v-td name="company" align="center">
                        {{ item.company }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Context",
    data() {
        return {
            isSync: false,
            foundOptions: [],
            uniq: 1,
        }
    },
    created() {
        this.$store.dispatch('dictionary/fetchCityOptions');
    },
    computed: {
        ...mapState({
            cityOptions: state => state.dictionary.cityOptions,
        }),
    },
    methods: {
        autoSetting(item) {
            if (item.auto) {
                this.axios.post(`/admin/context/${item.id}/auto/enable`)
            } else {
                this.axios.post(`/admin/context/${item.id}/auto/disable`)
            }
        },

        syncAds() {
            this.isSync = true
            this.axios.patch('/admin/context/sync').then(() => {
                this.isSync = false
                this.uniq++
            }).catch(() => {
                this.isSync = false
                this.uniq++
            })
        },
    },
}
</script>

<style scoped lang="scss">
header {
    display: flex;
    justify-content: space-between;
}
</style>
